module.exports = __webpack_public_path__ + "static/fonts/GodoM.1669dd1.woff";